import * as React from "react";
/**
 * Simple error presentation
 */
export class DefaultError extends React.Component {
    render() {
        return (React.createElement("sb-error-comp", null,
            React.createElement("h2", null, "Something went wrong."),
            React.createElement("details", { style: { whiteSpace: "pre-wrap" } },
                this.props.error && this.props.error.toString(),
                React.createElement("br", null),
                this.props.componentStack)));
    }
}
//# sourceMappingURL=DefaultError.js.map